import { IconButton, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";
import { FaArrowUp } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import { Briefcase } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import AttachJobModal from "./AttachJobModal";

const ChatInput = ({ onSubmit }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { isValid }
  } = useForm({ mode: "onChange" });

  const textareaRef = useRef(null);
  const message = watch("message", "");
  
  const { user } = useAuth();
  const [jobModalOpen, setJobModalOpen] = useState(false);

  const submit = handleSubmit((data) => {
    reset({ message: "" });
    onSubmit(data);
  });

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [message]);

  return (
    <div className="shrink-0 pt-3 px-2 pb-2 bg-white">
      <form
        onSubmit={submit}
        onKeyDown={handleKeyDown}
        className="flex items-center gap-3 px-4 py-2 rounded-2xl shadow-sm border border-gray-200 focus-within:ring-2 focus-within:ring-blue-500 transition-all"
      >
        {user?.role === "recruiter" && (
          <>
            <Tooltip title="Attach Job Advertisement">
              <IconButton onClick={() => setJobModalOpen(true)} size="small" className="text-gray-500 hover:text-blue-600 shrink-0">
                <Briefcase size={20} />
              </IconButton>
            </Tooltip>
            <AttachJobModal 
              open={jobModalOpen} 
              onClose={() => setJobModalOpen(false)}
              onSelectJob={(jobLink) => {
                const current = message;
                setValue("message", current ? `${current}\n\n${jobLink}` : jobLink, { shouldValidate: true, shouldDirty: true });
                setJobModalOpen(false);
                setTimeout(() => textareaRef.current?.focus(), 0);
              }}
            />
          </>
        )}
        <textarea
          {...register("message", {
            required: true,
            validate: (value) => value.trim().length > 0,
          })}
          ref={(e) => {
            register("message").ref(e);
            textareaRef.current = e;
          }}
          rows={1}
          placeholder="Type your message..."
          className="flex-1 resize-none bg-transparent outline-none text-sm max-h-40 overflow-y-auto"
        />

        <IconButton
  type="submit"
  disabled={!isValid}
  sx={{
    alignSelf: "flex-end",
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: isValid ? "#2563eb" : "#e5e7eb",
    color: isValid ? "#ffffff" : "#9ca3af",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: isValid ? "#1d4ed8" : "#e5e7eb"
    }
  }}
>
  <FaArrowUp size={14} />
</IconButton>
      </form>
    </div>
  );
};

export default ChatInput;